<template>
    <i class="material-icons" @click="$emit('click')">{{ icon }}</i>
</template>
<script>
export default {
    props: ['icon']
}
</script>